import { DELIVERY_TYPES } from 'config'
import { observable, decorate, action, computed, autorun } from 'mobx'

export class DeliveryUserInfoStore {
  userInfo = {}

  constructor(rootStore) {
    this.rootStore = rootStore

    autorun(() => {
      this.initUserInfo()
    })
  }

  get userInfoDone() {
    return this.rootStore.deliveryStore.deliveryOptionId != null &&
      this.rootStore.deliveryStore.type === DELIVERY_TYPES.PICKUP
      ? true
      : this.userInfo.firstname != null &&
        this.userInfo.firstname != null &&
        this.userInfo.lastname != null &&
        this.userInfo.email != null &&
        this.userInfo.phone != null
      ? true
      : false
  }

  setUserInfo(userInfo) {
    this.userInfo = userInfo
    // console.log('DELIVERY USER INFO UPDATED', toJS(this.userInfo))
  }

  setUserInfoField(field, value) {
    this.userInfo[field] = value
    // console.log('DELIVERY USER INFO UPDATED', toJS(this.userInfo))
  }

  clearUserInfo() {
    this.initUserInfo()
    // console.log('DELIVERY USER INFO CLEARED')
  }

  initUserInfo() {
    this.userInfo = {
    }

    // console.log('DELIVERY USER INFO INITIALIZATE', toJS(this.userInfo))
  }

  valuesHandler(event) {
    const name = event.target.name
    const nullableValue = event.target.value === '' ? null : event.target.value
    this.userInfo[name] = nullableValue
    // console.log(' DELIVERY USER INFO VALUE "', name, '" now is ', nullableValue)
  }
}

decorate(DeliveryUserInfoStore, {
  userInfo: observable,

  userInfoDone: computed,

  setUserInfo: action,
  setUserInfoField: action,
  clearUserInfo: action,
  initUserInfo: action,
  valuesHandler: action,
})
